import { type FragmentType, useFragment } from '@/gql/codegen';
import { graphql } from '@/gql/codegen/gql';
import type React from 'react';
import styles from './index.module.scss';

export const COURSE_LESSON_SCENARIO_STORY_TRANSITION_FRAGMENT =
  graphql(/* GraphQL */ `
  fragment EmbaCourseLessonScenarioStoryTransition on ScenarioContentTransition {
    ...on ScenarioContentTransition {
      text
    }
  }
`);

type TransitionProps = {
  currentStoryContent: FragmentType<
    typeof COURSE_LESSON_SCENARIO_STORY_TRANSITION_FRAGMENT
  >;
  isEnableNext: boolean;
  slideToNext: () => void;
};

export const Transition: React.FC<TransitionProps> = ({
  currentStoryContent,
  isEnableNext,
  slideToNext,
}) => {
  const currentStoryContentData = useFragment(
    COURSE_LESSON_SCENARIO_STORY_TRANSITION_FRAGMENT,
    currentStoryContent,
  );

  return (
    <div className={styles.contentArea}>
      <div
        className={styles.transition}
        onClick={isEnableNext ? () => slideToNext() : undefined}
      >
        <p>{currentStoryContentData.text}</p>
      </div>
    </div>
  );
};
